import { ConversationStep, Theme } from "../../interfaces";
import CriteriaCheck from "./CriteriaCheck";

import DefaultSteps from "../DefaultSteps";
import EscalationSteps from "../EscalationSteps";

const criteria = (theme: Theme) => {
    if (theme.customFlowData) {
        let mainFlow = theme.customFlowData.flow;
        if (theme.customFlowData.importedFlows) {
            const importedFlows = theme.customFlowData?.importedFlows.map((data: any) => data.flow);
            let combinedImportedFlows: any = [];
            importedFlows.forEach((data: any) =>
                data.forEach((_data: any) => combinedImportedFlows.push(_data))
            );
            mainFlow = [...mainFlow, ...combinedImportedFlows];
        }
        return [
            ...mainFlow,
            {
                id: "flow_not_supported",
                type: "bot",
                message: "This flow is not supported yet",
                end: true,
            },
            {
                id: "anything_else",
                custom_value: (value) => {
                    if (value === "New Search") {
                        return {
                            key: "criteria_input",
                            value: [],
                        };
                    }

                    return {
                        key: "anything_else",
                        value,
                    };
                },
                options: [
                    {
                        label: "Let's narrow this down",
                        value: "Let's narrow this down",
                        trigger: "criteria_input",
                    },
                    {
                        label: "New Search",
                        value: "New Search",
                        trigger: "mortgage_type",
                    },
                ],
                type: "bot",
            },
            ...EscalationSteps,
            ...CriteriaCheck(theme),
            ...DefaultSteps(theme),
        ] as ConversationStep[];
    }

    return [
        {
            id: "video_greeting",
            type: "bot",
            video: `${process.env.REACT_APP_COMMS_URL}/download/files/public/501P4533-7616-4574-35P5-5r1ar9716570.mp4`,
            trigger: "help_query",
        },
        {
            id: "help_query",
            type: "bot",
            message: "Hey – I’m Parker, the Criteria & Help Assistant. How can I help?",
            options: [
                {
                    label: "System Help",
                    value: "System Help",
                    trigger: "flow_not_supported",
                },
                {
                    label: "Criteria Check",
                    value: "Criteria Check",
                    trigger: "criteria_check_greeting",
                },
                {
                    label: "Contact Helpdesk",
                    value: "Contact Helpdesk",
                    trigger: "flow_not_supported",
                },
            ],
        },
        {
            id: "flow_not_supported",
            type: "bot",
            message: "This flow is not supported yet",
            end: true,
        },
        {
            id: "anything_else",
            custom_value: (value) => {
                if (value === "New Search") {
                    return {
                        key: "criteria_input",
                        value: [],
                    };
                }

                return {
                    key: "anything_else",
                    value,
                };
            },
            options: [
                {
                    label: "Let's narrow this down",
                    value: "Let's narrow this down",
                    trigger: "criteria_input",
                },
                {
                    label: "New Search",
                    value: "New Search",
                    trigger: "mortgage_type",
                },
            ],
            type: "bot",
        },
        ...EscalationSteps,
        ...CriteriaCheck(theme),
        ...DefaultSteps(theme),
    ] as ConversationStep[];
};

export default criteria;
